import React, { useState } from 'react';
import { ICONS } from '../../constants/imageConstants';
import { Button } from '../buttons/button';
import { cn } from '../../lib/utils';

const SyncSurveyCard = ({ title, description = "", pendingCount = 0, onViewList, onSyncNow, onSelect, isSelected, isSyncing = false }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const stopPropagation = (e, func) => {
    e.stopPropagation();
    if (func) func();
  };
  
  const isSyncDisabled = pendingCount === 0 || isSyncing;
  const hasLongDescription = (description || "").length > 0;

  return (
    <div 
      className="bg-white rounded-xl border border-gray-200 p-4 flex flex-col justify-between h-full min-h-[130px] shadow-sm transition-all duration-300 hover:shadow-lg hover:-translate-y-0.2 cursor-pointer relative"
      onClick={onSelect}
    >
      <div className={cn('absolute top-3 right-3 w-6 h-6 rounded-full border-2 flex items-center justify-center transition-all duration-200', isSelected ? 'bg-[var(--header-bg)] border-[var(--header-bg)]' : 'bg-white border-gray-300 hover:border-gray-400')}>
        {isSelected && (
          <svg className="w-4 h-4 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" /></svg>
        )}
      </div>

      <div className="flex-1 pr-10 mb-3">
        <span className="text-[14px] font-bold uppercase tracking-wider text-gray-800">
          {title}
        </span>

        <p
          className={cn(
            "mt-1 text-[12px] text-gray-600 leading-relaxed",
            !isExpanded && "line-clamp-2"
          )}
        >
          {description}
        </p>

        {hasLongDescription && (
          <button
            onClick={e => {
              e.stopPropagation();
              setIsExpanded(!isExpanded);
            }}
            className="mt-1.5 text-[11px] font-semibold text-[var(--header-bg)] hover:underline inline-flex items-center gap-1"
          >
            {isExpanded ? "Show less" : "Read more"}
            <svg
              className={cn("w-3 h-3 transition-transform duration-200", isExpanded && "rotate-180")}
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
            </svg>
          </button>
        )}
      </div>

      <div className="mt-auto">
        <div className="pt-3 border-t border-gray-50 flex items-center justify-between mb-3">
          <div className="flex items-center gap-1.5">
            <img src={ICONS.SYNC_YELLOW} alt="" className="w-5 h-5" />
            <span className="text-xs text-gray-600">
              Waiting to upload: <span className="font-bold text-gray-900">{pendingCount}</span>
            </span>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-2">
          <Button 
            onClick={e => stopPropagation(e, onSyncNow)} 
            variant="primary" 
            size="small" 
            disabled={isSyncDisabled}
            className="h-9"
          >
            <img 
              src={ICONS.SYNC} 
              alt="" 
              className={`w-5 h-5 mr-1.5 ${isSyncing ? 'animate-spin' : ''}`}
            />
            {isSyncing ? 'Syncing...' : 'Sync Now'}
          </Button>
          <Button 
            variant="outline" 
            size="small" 
            onClick={e => stopPropagation(e, onViewList)} 
            disabled={isSyncDisabled}
            className="h-9"
          >
            <img src={ICONS.SURVEY_COMPLETED} alt="" className="w-5 h-5 mr-1.5" />
            View Lists
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SyncSurveyCard;